import { TypedDocumentNode, gql } from '@apollo/client';

import { So5LeaderboardType, Sport } from '__generated__/globalTypes';
import { DumbPastWinner } from 'components/landing/CommunityBlock/DumbPastWinner';
import useQuery from 'hooks/graphql/useQuery';

import {
  AnySportPastLineupWinnerQuery,
  AnySportPastLineupWinnerQueryVariables,
} from './__generated__/index.graphql';

const ANY_SPORT_PAST_LINEUP_WINNER_QUERY = gql`
  query AnySportPastLineupWinnerQuery(
    $leaderboardType: So5LeaderboardType!
    $sport: Sport!
  ) {
    so5 {
      so5Fixture(type: PAST, sport: $sport) {
        slug
        displayName
        so5Leaderboard(so5LeaderboardType: $leaderboardType) {
          slug
          displayName
          svgLogoUrl
          mainRarityType
          so5LineupsCount
          so5Rankings(first: 1) {
            nodes {
              id
              score
              ranking
              so5Lineup {
                id
                so5Appearances {
                  id
                  pictureUrl
                }
                user {
                  slug
                  nickname
                  pictureUrl
                }
              }
            }
          }
        }
      }
    }
  }
` as TypedDocumentNode<
  AnySportPastLineupWinnerQuery,
  AnySportPastLineupWinnerQueryVariables
>;

type Props = {
  sport: Sport;
  leaderboardType: So5LeaderboardType;
};

export const AnySportPastWinner = ({ leaderboardType, sport }: Props) => {
  const { data } = useQuery(ANY_SPORT_PAST_LINEUP_WINNER_QUERY, {
    variables: { leaderboardType, sport },
  });

  const leaderboardDataSimplified = data?.so5.so5Fixture?.so5Leaderboard;
  const lineupDataSimplified =
    leaderboardDataSimplified?.so5Rankings.nodes[0]?.so5Lineup;

  if (!lineupDataSimplified || !leaderboardDataSimplified?.so5LineupsCount)
    return null;
  return (
    <DumbPastWinner
      cards={lineupDataSimplified.so5Appearances.map(appearance => ({
        imageUrl: appearance.pictureUrl,
      }))}
      leaderboardIconUrl={leaderboardDataSimplified.svgLogoUrl}
      leaderboardName={leaderboardDataSimplified.displayName}
      leaderboardRarity={leaderboardDataSimplified.mainRarityType}
      lineupsCount={leaderboardDataSimplified.so5LineupsCount}
      winner={{
        nickname: lineupDataSimplified.user.nickname,
        avatarUrl: lineupDataSimplified.user.pictureUrl,
      }}
      score={leaderboardDataSimplified.so5Rankings.nodes[0].score}
    />
  );
};
